import { memo } from 'react';
import { Card, CardBody, Flex, Text } from '@backstage/ui';

type InsightsSummaryCardProps = {
  title: string;
  value: string | number;
  subtitle?: string;
};

export const InsightsSummaryCard = memo(
  ({ title, value, subtitle }: InsightsSummaryCardProps) => (
    <Card style={{ height: '100%' }}>
      <CardBody>
        <Flex direction="column" gap="2">
          <Text variant="body-large" color="secondary">
            {title}
          </Text>
          <Text variant="title-small" weight="bold">
            {value}
          </Text>
          {subtitle && (
            <Text variant="body-small" color="secondary">
              {subtitle}
            </Text>
          )}
        </Flex>
      </CardBody>
    </Card>
  ),
);
